export default "__VITE_ASSET__62b19aac__"